import Component from "vue-class-component";
import { Mixins } from "vue-property-decorator";
import { ChartConfigItemBaseMixin } from "./chart-config-item-base.mixin";

/**
 * Echarts 图表控件（echarts chart config item）的公共基础类
 *
 * @export
 * @class ChartConfigItemBaseMixin
 * @extends {Mixins(ChartConfigItemBaseMixin)}
 */
@Component
export class EchartsChartConfigItemMixin extends Mixins(
  ChartConfigItemBaseMixin,
) {}
